import React from "react";
import RelatePlayStatistic from "./RelatePlayStatistic";
import useTopicWork from "common/topic/provider/TopicWork";

const Statistic = () => {
  const { topicWork } = useTopicWork();

  return (
    <div>
      <div>Statistic</div>
      {topicWork && (
        <div>
          <RelatePlayStatistic topicId={topicWork.id} />
        </div>
      )}
    </div>
  );
};

export default Statistic;
